/**
 * Context for sharing device approval status across the app.
 * Allows components to react to pending/approved state without blocking.
 */

import { createContext, useContext } from 'react';

export type DeviceStatus = 'unknown' | 'approved' | 'pending';

export const DeviceStatusContext = createContext<DeviceStatus>('unknown');

export const useDeviceStatus = () => useContext(DeviceStatusContext);
